import allTideStations from '../allTideStations'
import moment from '../lib/moment'
import GoogleMaps from './google-maps-api'




// ==========================
// = NOAA Tides API service =
// ==========================
//
// Interface for NOAA's Tide & Currents API
//
// see documentation:
// - Metadata on stations https://tidesandcurrents.noaa.gov/mdapi/latest/
// - Station observation & predicitons https://tidesandcurrents.noaa.gov/api/
//






// Organize master tide stations array into object by stationId
const allTideStationsById = {}
allTideStations.forEach(station => {
  allTideStationsById[station.stationId] = station
})

// Add a GoogleMaps.LatLng object to every station (to improve sorting
// performance)
allTideStations.forEach(station => {
  const latlng = {
    lat: parseFloat(station.lat),
    lng: parseFloat(station.lng)
  }
  station.loc = new GoogleMaps.LatLng(latlng)
})










const NOAATides = {}





// =================
// = Tide Stations =
// =================

NOAATides.getStations = (args={}) => {
  performance.mark('TideStationFilter-start')

  const { filterBy } = args

  if (filterBy == null || filterBy.trim() === '') {
    return allTideStations.slice()
  }
  else {
    let   queryTerms       = filterBy.match(/\w+/g) || []
    const queryRegexpArray = queryTerms.map(term => {
      return RegExp(term, 'i')
    })

    const filteredList = allTideStations.filter(station => {
      const searchMaterial = station.name + station.stationId

      let allMatch = true
      for (const regexp of queryRegexpArray) {
        if (!regexp.test(searchMaterial)) {
          allMatch = false
          break
        }
      }

      return allMatch
    })

    performance.mark('TideStationFilter-finish')
    performance.measure(
      'TideStationFilter',
      'TideStationFilter-start',
      'TideStationFilter-finish'
    )

    return filteredList
  }
}

NOAATides.getStationById = (stationId) => {
  return allTideStationsById[stationId]
}

NOAATides.getClosestStation = (latlng) => {
  console.log('getting closest station...')
  performance.mark('NOAATides.getClosestStation-start')
  // 1. create stations array w/ distances
  const stationDistances = allTideStations.map(station => {
    const dist = GoogleMaps.computeDistanceBetween(latlng, station.loc)
    return {dist, station}
  })

  // 2. sort by distances
  stationDistances.sort((a, b) => a.dist - b.dist)

  performance.mark('NOAATides.getClosestStation-finish')
  performance.measure(
    'NOAATides.getClosestStation',
    'NOAATides.getClosestStation-start',
    'NOAATides.getClosestStation-finish'
  )

  // 3. return first item
  return stationDistances[0].station
}








// =============
// = Tides API =
// =============

export const TIDE_TYPES = {
  HIGH: 'High',
  LOW:  'Low'
}

const NoaaBaseUrl = 'https://api.tidesandcurrents.noaa.gov/api/prod/datagetter?'
const DateFormat = 'YYYYMMDD%20HH:mm'

NOAATides.getTides = (stationId, requestedRange) => {

  if (typeof(stationId) !== 'string')
    throw new TypeError('`stationId` must be a string')
  if (!moment.isRange(requestedRange))
    throw new TypeError('`requestedRange` must be a moment.range (see npm moment-range)')

  const fetchRange = requestedRange.clone()
  if (fetchRange.diff('hours', true) < 15)
    fetchRange.end = fetchRange.start.clone().add(15, 'hours')

  const request = {
    station:      stationId,
    begin_date:   fetchRange.start.format(DateFormat),
    end_date:     fetchRange.end.format(DateFormat),
    product:      'predictions',
    datum:        'mllw',
    interval:     'hilo',
    units:        'english', // 'english' || 'metric'
    time_zone:    'lst_ldt',
    application:  'tides.pmlord.com',
    format:       'json'
  }

  const queryString = Object.entries(request).map(ary => {
    return `${ary[0]}=${ary[1]}`
  }).join('&').replace(' ', '%20')

  const url = NoaaBaseUrl + queryString

  return fetch(url)
    .then(response => response.json())
    .then(response => {
      if (response.predictions) {
        const receivedTides = response.predictions
        receivedTides.forEach(tide => {
          tide.stationId = stationId
          tide.id        = `${stationId}:${tide.t}`
          tide.moment    = moment(tide.t)
          tide.type      = (tide.type === 'H') ? TIDE_TYPES.HIGH : TIDE_TYPES.LOW
          tide.v         = parseFloat(tide.v)
        })
        const tides = receivedTides.filter(tide => tide.moment.within(requestedRange))
        return Promise.resolve(tides)
      }
      else if (response.error) {
        return Promise.reject(response.error)
      }
    })
}






export default NOAATides
window.NOAATides = NOAATides







// =============
// = Utilities =
// =============

// Get performance average of station filter
window.filterAvg = () => {
  const p   = performance.getEntriesByName('TideStationFilter')
  const sum = p.reduce((mem, val) => mem + val.duration, 0)
  const len = p.length
  return {
    avg: sum / len,
    n: len
  }
}







// =========
// = Notes =
// =========

// Portland stationId
// '8418150'



// WEBPACK FOOTER //
// ./src/services/NOAATides.js